import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner } from "react-bootstrap";
import DateBlock from '../home/DateBlock';
import moment from "moment";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import { Link, withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import MultiSelect from "react-multi-select-component";
import "./_assignment.scss"
import AssignmentCreationModal from './AssignmentCreationModal';
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';
import DeleteModal from './DeleteModal';
import CreationDetailsModal from './CreationDetailsModal';


const DELETE_DIARY_ROW_DATA = gql`
   mutation($dairyAssignmentId:ID){
    deleteDairyAssignmentData(dairyAssignmentId:$dairyAssignmentId)
    }
 `;



class AssignmentHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch: "",
            class: "",
            exam: "",
            section: "",
            subject: "",
            lecturer: "",
            branchError: "",
            classError: "",
            examError: "",
            sectionError: "",
            subjectError: "",
            lecturerError: "",
            getExams: [],
            getClasses: [],
            getSections: [],
            getSubjects: [],
            getEmployees: [],
            getMainEmployees: [],
            employeesData: [],
            examValue: [],
            classValue: [],
            sectionValue: [],
            subjectValue: [],
            lectureValue: [],
            defaultvalue: 0,
            assignSubmittedDate: [],
            loader: 0,
            assignmentCreationModal: false,
            submitted: false,
            assignCreationData: [],
            // date: new Date().toISOString().slice(0, 10),

            startDateCalender: moment(new Date()).subtract(1, "month").startOf('day').unix(),
            endDateCalender: moment(new Date()).startOf('day').unix(),
            loadingSpinner: "",
            spinnerStatus: "",
            submitError: "",
            DiaryResponseModal: false,
            creationDetailsModal: false,
            exam_id: "",
            existingAssignmentData: [],
            noDateError: "",
            assignStudentStatusData: [],
            deleteModal: false,
            rowData: []
        }
    }





    handleInputChange = async (e) => {
        const name = e.target.name;
        const value = e.target.value;


        let getArray = [];

        if (name == "branch") {
            if (value != "0") {

                let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    branch: value,
                    branchError: "",
                    section: "",
                    sectionError: "",
                    class: "",
                    classError: "",
                    exam: "",
                    examError: "",
                    subject: "",
                    subjectError: "",
                    lecturer: "",
                    lecturerError: "",
                    getClasses: [],
                    getSections: [],
                    getExams: getArray,
                    sectionValue: [],
                    subjectValue: [],
                    lectureValue: [],
                    assignCreationData: [],
                    submitted: false,
                    noDateError: "",
                    loader: ""
                })

            } else {

                this.setState({
                    branch: "",
                    branchError: "",
                    section: "",
                    sectionError: "",
                    class: "",
                    classError: "",
                    exam: "",
                    examError: "",
                    subject: "",
                    subjectError: "",
                    lecturer: "",
                    lecturerError: "",
                    getExams: [],
                    getClasses: [],
                    getSections: [],
                    sectionValue: [],
                    subjectValue: [],
                    lectureValue: [],
                    assignCreationData: [],
                    submitted: false,
                    noDateError: "",
                    loader: ""
                })
            }
        }

        if (name == "exam") {

            if (value != "0") {


                let uniqueClasses = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch && item.exam_id == value).map((item1) => item1.class_id))].sort();

                uniqueClasses.map((val) => {
                    let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    branchError: "",
                    section: "",
                    sectionError: "",
                    class: "",
                    classError: "",
                    exam: value,
                    examError: "",
                    subject: "",
                    subjectError: "",
                    lecturer: "",
                    lecturerError: "",
                    getClasses: getArray,
                    getSections: [],
                    sectionValue: [],
                    subjectValue: [],
                    lectureValue: [],
                    submitted: false,
                    assignCreationData: [],
                    noDateError: "",
                    loader: ""
                })

                this.getEmployess()
            } else {
                this.setState({
                    branchError: "",
                    section: "",
                    sectionError: "",
                    class: "",
                    classError: "",
                    exam: "",
                    examError: "",
                    subject: "",
                    subjectError: "",
                    lecturer: "",
                    lecturerError: "",
                    getSections: [],
                    getClasses: [],
                    sectionValue: [],
                    subjectValue: [],
                    lectureValue: [],
                    submitted: false,
                    assignCreationData: [],
                    noDateError: "",
                    loader: ""  
                })

            }
        }

        if (name == "class") {

            if (value != "0") {

                let uniqueSections = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch && item.exam_id == this.state.exam && item.class_id == value).map((item1) => item1.section_id))].sort();

                uniqueSections.map((val) => {
                    let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualSectionData.id,
                        label: individualSectionData.section_name
                    }
                    getArray.push(newObj);
                })

                let sections = getArray.map((item) => item.value).toString();

                let examWiseSubjects = [];

                let employeesdata = this.state.getEmployees.filter((item)=> item.value == Cookies.get("id"))
                console.log("employeesdata", employeesdata);      

                if(employeesdata.length > 0){
                    let subjectIdsArray = employeesdata[0].subject_id.split(",")
                    
                    subjectIdsArray.forEach(subjectId => {
                        const foundSubject = this.props.globals.offlineExamSubjects.filter(item2 => item2.id === +subjectId);
                        if (foundSubject) {
                            foundSubject.map((item)=>{
                                const newObj = {
                                    value: item.id,
                                    label: item.subject
                                };
                                examWiseSubjects.push(newObj);
                                console.log("examWiseSubjects", examWiseSubjects);
                            })
                           
                        }
                    });
                }else{
                    if (this.props.globals.offlineExamSubjects.length > 0) {
                        this.props.globals.exams.filter((item) => item.id == this.state.exam)[0].exam_subjects.map((item1) => {
                            this.props.globals.offlineExamSubjects.map((item2) => {
                                if (item1.subject_id == item2.id) {
                                    const newObj = {
                                        value: item2.id,
                                        label: item2.subject
                                    }
                                    examWiseSubjects.push(newObj);
                                }
                            })
                        })
                    }
                }
                    
                

                let lecturesData = [];
                  let uniquEmp =new Set()

                  if(employeesdata.length > 0){
                           employeesdata.map((item)=>{
                            const newObj = {
                                value: item.value,
                                label: item.label
                            }
                            lecturesData.push(newObj)

                           })
                  }else{
                    examWiseSubjects.map((item2) => {
                        this.state.getEmployees.map((item3) => {
                            const subjectIdsArray = item3.subject_id.split(',');
    
                            if (subjectIdsArray.includes(item2.value.toString())) {
                                if (!uniquEmp.has(item3.value)) {
                                    uniquEmp.add(item3.value);
                                    lecturesData.push(item3);
                                }
                            }
                        });
                    });
                  }

                
                console.log("lecturesData", lecturesData);

                this.setState({
                    branchError: "",
                    section: sections,
                    sectionError: "",
                    class: value,
                    classError: "",
                    examError: "",
                    subject: "",
                    subjectError: "",
                    lecturer: "",
                    lecturerError: "",
                    getSubjects: examWiseSubjects,
                    subjectValue: examWiseSubjects,
                    getSections: getArray,
                    sectionValue: getArray,
                    getMainEmployees: lecturesData,
                    lectureValue: lecturesData,
                    submitted: false,
                    assignCreationData: [],
                    noDateError: "",
                    loader: ""
                })

            } else {

                this.setState({
                    branchError: "",
                    section: "",
                    sectionError: "",
                    class: "",
                    classError: "",
                    examError: "",
                    subject: "",
                    getSubjects: [],
                    subjectError: "",
                    lecturer: "",
                    getMainEmployees: [],
                    lecturerError: "",
                    getSections: [],
                    sectionValue: [],
                    subjectValue: [],
                    lectureValue: [],
                    submitted: false,
                    assignCreationData: [],
                    noDateError: "",
                    loader: "",
                })

            }

        }

    };

    handleMultipleSelectInputChange = async (e, name) => {
        console.log("multi", e);

        if (name == "sections") {
            let getSections = []
            let sectionValue = []

            let section = "";
            if (e.length > 0) {

                for (let i = 0; i < e.length; i++) {
                    const sectionVal = e[i];
                    const newObj = {
                        label: sectionVal.label,
                        value: sectionVal.value
                    }
                    sectionValue.push(newObj)
                }
                section = e.map((item) => item.value).toString()
                let sectionWiseSubjects = []
                if (this.props.globals.offlineExamSubjects.length > 0) {
                    this.props.globals.exams.filter((item) => item.id == this.state.exam)[0].exam_subjects.map((item1) => {
                        this.props.globals.offlineExamSubjects.map((item2) => {
                            if (item1.subject_id == item2.id) {
                                const newObj = {
                                    value: item2.id,
                                    label: item2.subject
                                }
                                sectionWiseSubjects.push(newObj);

                            }
                        })
                    })
                }

                let sectionWiseLecturer = []
                let uniqEmp = new Set()

                sectionWiseSubjects.map((item2) => {
                    this.state.getEmployees.map((item3) => {
                        const subjectIdsArray = item3.subject_id.split(',');

                        if (subjectIdsArray.includes(item2.value.toString())) {
                            if (!uniqEmp.has(item3.value)) {
                                uniqEmp.add(item3.value);
                                sectionWiseLecturer.push(item3);
                            }
                        }
                    });
                });

                this.setState({
                    sectionValue: sectionValue,
                    sectionError: "",
                    section: "",
                    subject: "",
                    getSubjects: sectionWiseSubjects,
                    subjectValue: sectionWiseSubjects,
                    getMainEmployees: sectionWiseLecturer,
                    lectureValue: sectionWiseLecturer,
                    subjectError: "",
                    submitted: false,
                    assignCreationData: [],
                    noDateError: "",
                    loader: ""
                });

            } else {
                this.setState({
                    sectionValue: [],
                    sectionError: "",
                    section: "",
                    subject: "",
                    subjectError: "",
                    getSubjects: [],
                    subjectValue: [],
                    getMainEmployees: [],
                    lectureValue: [],
                    submitted: false,
                    assignCreationData: [],
                    noDateError: "",
                    loader: ""
                });
            }
        }
        console.log("getemployees", this.state.getMainEmployees)

        if (name == "subjects") {
            let subject = "";
            let subjectValue = [];
            if (e.length != 0) {
                for (let i = 0; i < e.length; i++) {
                    const subjectVal = e[i];
                    console.log("subjectVal", subjectVal);
                    const newObj = {
                        value: subjectVal.value,
                        label: subjectVal.label,

                    }
                    subjectValue.push(newObj)
                }

                console.log("lecturers", subjectValue);

                let subjectWiseLecturer = [];
                let uniqueValues = new Set()
                subjectValue.forEach((item4) => {
                    let lecturers = this.state.getEmployees.filter((a) => a.subject_id.includes( item4.value.toString())).map((lec) => ({
                        value: lec.value,
                        label: lec.label,
                    }))
                    lecturers.forEach((lecturer) => {
                        if (!uniqueValues.has(lecturer.value)) {
                            uniqueValues.add(lecturer.value); 
                            subjectWiseLecturer.push(lecturer);
                        }
                    });
                
                })   
                console.log("k", subjectWiseLecturer)

                this.setState({
                    subjectValue: subjectValue,
                    subjectError: "",
                    subject: "",
                    lecture: "",
                    getMainEmployees: subjectWiseLecturer,
                    lectureValue: subjectWiseLecturer,
                    lecturerError: "",
                    submitted: false,
                    assignCreationData: [],
                    noDateError: "",
                    loader: "",

                });

            } else {
                this.setState({
                    subjectValue: [],
                    subjectError: "",
                    subject: "",
                    lecture: "",
                    getMainEmployees: [],
                    lecturerError: "",
                    lectureValue: [],
                    submitted: false,
                    assignCreationData: [],
                    noDateError: "",
                    loader: "",
                });
            }
        }


        if (name == "lectures") {

            let lecture = "";
            if (e.length > 0) {
                lecture = e.map((item) => item.value).toString()
                this.setState({
                    lectureValue: e,
                    lecturerError: "",
                    lecture,
                    submitted: false,
                    assignCreationData: [],
                    noDateError: "",
                    loader: ""
                });

            } else {
                this.setState({
                    lectureValue: [],
                    lecturerError: "",
                    lecture: "",
                    submitted: false,
                    assignCreationData: [],
                    noDateError: "",
                    loader: ""
                });
            }

        }
    }

    getEmployess = async () => {

        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,){
                getEmployees(institute_id:$institute_id,branch_id:$branch_id){
                  employee_id
                  employee_name
                  subject_ids
                  employee_type_id
                }
              }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch)
            },
            fetchPolicy: 'network-only'
        })
        let employeeFilterData = result.data.getEmployees.filter((a) => a.employee_type_id == 3)
        console.log("result.data.getEmployees", employeeFilterData);
        if (employeeFilterData.length > 0) {
            let data = [];
            employeeFilterData.map((item) => {
                const newObj = {
                    value: item.employee_id,
                    label: item.employee_name,
                    subject_id: item.subject_ids
                }
                data.push(newObj);
            })
            this.setState({ getEmployees: data })

        } else {
            this.setState({ getEmployees: [] })
        }
    };


    getDisplayData = async (e) => {


        if (this.state.branch === "" || this.state.branch === "--Select Branch--") {
            this.setState({ branchError: "Please select branch" });
            return ""
        }


        if (this.state.exam === "" || this.state.exam === "--Select Exam--") {
            this.setState({ examError: "Please Select exam" });
            return ""
        }

        if (this.state.class === "" || this.state.class === "--Select Class--") {
            this.setState({ classError: "Please select class" });
            return ""
        }


        if (!this.state.sectionValue.length) {
            this.setState({ sectionError: "Please select section" });
            return ""
        }


        if (!this.state.subjectValue.length) {
            this.setState({ subjectError: "Please select Subject" });
            return ""
        }


        if (!this.state.lectureValue.length) {
            this.setState({ lecturerError: "Please select lecture" });
            return ""
        }

        this.setState({ loader: 1 })


        const result = await this.props.client.query({
            query: gql`
              query($institute_id:Int,$branch_id:Int,$dairy_assignment_type_id:Int,$from_date:String,$to_date:String){
                getStudentDairyAssignmentDetails(institute_id:$institute_id,branch_id:$branch_id,dairy_assignment_type_id:$dairy_assignment_type_id,from_date:$from_date,to_date:$to_date){

                    dairy_assignment_creation_details
                    {
                        
                        dairyAssigment_id
                        title
                        description
                        file_path
                        assignment_marks
                        to_date
                        from_date
                        employee_id
                        exam_id
                        class_id
                        subject_id
                        section_ids
                        Class
                        Exam
                        Section_Name
                        subject_name
                  

                    }

                        dairy_assignment_submitted_details
                    {
                        dairyAssignmentStatus_id
                        dairy_assignment_id                  
                        edu_student_id
                        status
                        upload_file_path
                        comments
                        submitted_time
                        student_name
                        student_mobile
                        roll_no
                        parent_name
                        parent_mobile
                        class_id
                        exam_id
                        section_id
                        marks
                        verifier_comments
                        timestamp
                     }
                     
                     
                        total_students_details
                     {
                        edu_student_id
                        student_name
                        student_mobile
                        roll_no
                        parent_name
                        parent_mobile
                        class_id
                        exam_id
                        section_id
                     }
                    }
                }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch),
                dairy_assignment_type_id: parseInt(3),
                from_date: this.state.startDateCalender.toString(),
                to_date: this.state.endDateCalender.toString(),
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getStudentDairyAssignmentDetails.length > 0) {

            console.log("dataaaaaaaaaaaaa", result.data.getStudentDairyAssignmentDetails);
            let data = result.data.getStudentDairyAssignmentDetails[0].dairy_assignment_creation_details;



             
            const examFilter = this.state.getExams.map(item => item.value);
            const classFilter = this.state.getClasses.map(item => item.value.toString());
            const sectionFilter = this.state.sectionValue.map(item => item.value);
            const subjectFilter = this.state.subjectValue.map(item => item.value.toString());
            const lectureFilter = this.state.lectureValue.map(item => item.value.toString());

            const filteredArray = data.filter(item => {
                const itemExamId = item.exam_id.split(',');

                const itemClassId = item.class_id.split(',');

                const itemSectionIds = item.section_ids.split(',');

                const itemSubject = item.subject_id.toString().split(',');

                const itemEmployeeId = item.employee_id.toString().split(',');

                console.log("ddddd", subjectFilter, itemExamId, itemClassId, itemSectionIds, itemSubject, itemEmployeeId, classFilter, examFilter, sectionFilter, subjectFilter, lectureFilter, this.state.getClasses);

                const examMatch = itemExamId.some(id => examFilter.includes(id));
                const classMatch = itemClassId.some(id => classFilter.includes(id));
                const sectionMatch = itemSectionIds.some(id => sectionFilter.includes(id));
                const subjectMatch = itemSubject.some(id => subjectFilter.includes(id));
                const employeeMatch = itemEmployeeId.some(id => lectureFilter.includes(id));
                console.log("ddddd1", examMatch, classMatch, sectionMatch, subjectMatch, employeeMatch);
                return examMatch && classMatch && sectionMatch && subjectMatch && employeeMatch;
            });

            console.log("filteredArray", filteredArray);
            console.log("result", data);
            this.setState({
                assignCreationData: filteredArray,
                submitted: false,
                assignSubmittedDate: result.data.getStudentDairyAssignmentDetails[0].dairy_assignment_submitted_details,
                loader: 0,
                noDateError: "",

            })

        } else {
            this.setState({
                loader: 0,
            })
        }

        if (result.data.getStudentDairyAssignmentDetails.length > 0) {

            let data2 = result.data.getStudentDairyAssignmentDetails[0].total_students_details;

            this.setState({
                assignStudentStatusData: data2
            })
        }
        if(this.state.assignCreationData.length == 0){
            this.setState({
                noDateError:"No Data Available"
            })
        }

    }

    applyCallback = (startDate, endDate) => {
        console.log(endDate, startDate, "endDate")
        this.setState({
            branch: "",
            class: "",
            exam: "",
            section: "",
            subject: "",
            lecturer: "",
            assignCreationData: [],
            noDateError: "",
            startDateCalender: startDate.startOf('day').unix(),
            endDateCalender: endDate.startOf('day').unix(),
            getExams: [],
            getClasses: [],
            getSections: [],
            getEmployees: [],
            getSubjects: [],
            examValue: [],
            classValue: [],
            sectionValue: [],
            subjectValue: [],
            getMainEmployees: [],
            lectureValue: [],
        })
    }

     

    articlecolumns = [
        {
            dataField: "from_date",
            text: "Assigned Date",
            sort: true,
        },

        {
            dataField: "to_date",
            text: "Submitted Date",
            sort: true,
        },

        {
            dataField: "title",
            text: "Assignment",
            formatter: this.AssignCreationFunc.bind(this),
        },
        {
            dataField: "section_ids",
            text: "Section",
        },
        {
            dataField: "lectureAndSubject",
            text: "Lecture",
        },
        {
            dataField: "Edit",
            formatter: this.EditFunc.bind(this),
            text: "Edit",
        },
        {
            dataField: "Delete",
            formatter: this.DeleteFunc.bind(this),
            text: "Delete",
        },
        {
            dataField: "Student Status",
            formatter: this.NextPageFunc.bind(this),
            text: "Status Details"
        },

    ];

    AssignCreationFunc(val, row) {
        console.log(row, "wwwwww")
        return (<>
            <div>
                <a
                    href="#"
                    onClick={() => this.setState({ creationDetailsModal: true, rowData: row.rowData })}
                >
                    {row.title}
                </a>
            </div>
        </>)
    };

    EditFunc(val, row) {
        console.log(row, "mmmmmmm")
        return (<>
            <div className="actions-buttons d-flex justify-content-center align-items-top">
                <Button variant="link" name="view" className="text-theme" onClick={() => { this.setState({ assignmentCreationModal: true, id: row.dairyAssignmentId, existingAssignmentData: [row] }) }}>
                    <i className="fas fa-edit" />
                </Button>
            </div>
        </>)
    }

    handleDelete = async (id) => {

        if (window.confirm("Do You Want to Delete")) {
            let dairyAssignmentId = parseInt(id)

            this.deleteDairyAssignmentData1(
                dairyAssignmentId
            ).catch(error => {
                console.log("error", error);
                this.setState({
                    submitError: error.graphQLErrors.map(x => x.message),
                    loadingSpinner: 0
                });
                console.error("ERR =>", error.graphQLErrors.map(x => x.message));
            });
            this.setState({ loadingSpinner: 1, deleteModal: true })        }

        
    }

    deleteDairyAssignmentData1 = async (
        dairyAssignmentId) => {
        await this.props.deleteDairyAssignmentData({
            variables: {
                dairyAssignmentId,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.deleteDairyAssignmentData) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                        submitted: "Deleted Successfully...",
                        spinnerStatus: ""
                    });
                    window.location.reload(false);
                }
            }
        });
    };

    tableData(data) {
        let returnData = [];
        data.map((mapData) => {
            console.log(mapData, "mapData")
            let section_name = [];
            let lecture_name = "";

            this.props.globals.globalSections.forEach((stumap1) => {
                if (mapData.section_ids.includes(stumap1.id)) {
                    section_name.push(stumap1.section_name);
                }
            });
            const joined_section_names = section_name.join(', ');

            this.state.getEmployees.map((item) => {
                if (item.value == mapData.employee_id) {
                    lecture_name = item.label
                }
            })

            const sub = mapData.subject_name || "";
            const lecture = lecture_name || "";

            let lectureAndSubject = lecture;

            if (lecture && sub) {
                lectureAndSubject = `${lecture} - ${sub}`

            } else {
                lectureAndSubject = lecture || sub;
            }
            const newObj = {
                branch_id: parseInt(Cookies.get("branch_id")),
                title: mapData.title,
                from_date: moment.unix(mapData.from_date).format("DD-MM-YYYY"),
                to_date: moment.unix(mapData.to_date).format("DD-MM-YYYY"),
                section_ids: joined_section_names,
                lectureAndSubject: lectureAndSubject,
                // employee_id: lecture_name,
                dairyAssignmentId: mapData.dairyAssigment_id,
                class_id: mapData.class_id,
                exam_id: mapData.exam_id,
                marks: mapData.assignment_marks,
                file_path: mapData.file_path,
                description: mapData.description,
                section_id: mapData.section_ids,
                subject_i: mapData.subject_id,
                employee_i: mapData.employee_id,
                rowData: mapData

            }
            returnData.push(newObj);

        });
        return returnData;

    }

    DeleteFunc(val, row) {
        console.log("roww", row.dairyAssignmentId);
        return (<>
            <div className="actions-buttons d-flex justify-content-center align-items-top">
                <Button variant="link" name="view" className="text-theme" onClick={() => { this.handleDelete(row.dairyAssignmentId) }}>
                    <i className="far fa-trash-alt text-danger" />
                </Button>
            </div>
        </>)
    }
 

    onClickNext(data) {
        const lectureAssignCreation = this.state.assignCreationData.filter((item) => item.dairyAssigment_id == data.dairyAssignmentId);
        console.log("dairyAssignmentId", lectureAssignCreation)

        const individualSectionStudents = this.state.assignStudentStatusData.filter((item) => {
            return (
                lectureAssignCreation[0] && lectureAssignCreation[0].exam_id.includes(item.exam_id)

            )
        })

        console.log(individualSectionStudents, "individualSectionStudents")
        console.log(lectureAssignCreation[0] && lectureAssignCreation[0].exam_id, "lectureAssignCreation")
        console.log(this.state.assignStudentStatusData, "Student")

        const classidfilter = individualSectionStudents.filter((item) => {
            return (
                lectureAssignCreation[0] && lectureAssignCreation[0].class_id.includes(item.class_id)
            )
        })

        const sectionfilter = classidfilter.filter((item) => {
            return (
                lectureAssignCreation[0] && lectureAssignCreation[0].section_ids.includes(item.section_id)

            )
        })

        console.log(sectionfilter, "classfilter")


        let statusSubmitData = []
        let statusNotSeenData = [] 

        if(this.state.assignSubmittedDate !== 0 && this.state.assignSubmittedDate !== undefined){
            statusSubmitData=  this.state.assignSubmittedDate.filter((item) => item.dairy_assignment_id == data.dairyAssignmentId)

         statusNotSeenData = sectionfilter.filter((student) => {
            const hasSubmitted = statusSubmitData.find((submittedStudent) => {
                return (
                    submittedStudent.edu_student_id == student.edu_student_id
                );
            });

            return !hasSubmitted;
        });}
        console.log(statusNotSeenData, "statusNotSeenData")

        this.props.history.push({
            pathname: "/assignment/view_details",
            state: {
                getStudentDairyAssignmentDetails: { statusSubmitData, statusNotSeenData, lectureAssignCreation }
            }
        });
    
 }

    NextPageFunc(row, col) {
        console.log("kkkkkkkkkkk", col);
        return (<>
            <div className="actions-buttons d-flex justify-content-center align-items-top">
                <Button variant="link" name="view" className="text-theme">
                    <i className="fas fa-arrow-right" style={{ fontSize: "15px",color:"#213046" }} onClick={() => this.onClickNext(col)} /><span className='tooltiptext1'>{col.id}</span>
                </Button>
            </div>
        </>)
    }

    render() {

        console.log(this.state, "state")

        let examSelectall = true;
        let examlabelledby = "--Select Exams--";
        let examdisableSearch = false;
        if (this.state.getExams.length > 0) {
            examSelectall = true;
            examdisableSearch = false;
        } else {
            examdisableSearch = true;
            examSelectall = false;
            examlabelledby = "--Select Exams--"
        }

        let classSelectall = true;
        let classlabelledby = "--Select Classes--";
        let classdisableSearch = false;
        if (this.state.getClasses.length > 0) {
            classSelectall = true;
            classdisableSearch = false;
        } else {
            classdisableSearch = true
            classSelectall = false;
            classlabelledby = "--Select Classes--";
        }

        let sectionSelectAll = true;
        let sectionlabelledby = "--Select Sections--";
        let sectiondisablesearch = false;
        if (this.state.getSections.length > 0) {
            sectionSelectAll = true;
            sectiondisablesearch = false;
        }
        else {
            sectiondisablesearch = true;
            sectionSelectAll = false;
            sectionlabelledby = "--Select Sections--"
        }


        let subjectSelectAll = true;
        let subjectlabelledby = "--Select Subjects--";
        let subjectdisablesearch = false;
        if (this.state.getSubjects.length > 0) {
            subjectSelectAll = true;
            subjectdisablesearch = false;
        }
        else {
            subjectdisablesearch = true;
            subjectSelectAll = false;
            subjectlabelledby = "--Select Subjects--"
        }


        let lectureSelectAll = true;
        let lecturelabelledby = "--Select Lectures--";
        let lecturedisablesearch = false;
        if (this.state.getEmployees.length > 0) {
            lectureSelectAll = true;
            lecturedisablesearch = false;
        }
        else {
            lecturedisablesearch = true;
            lectureSelectAll = false;
            lecturelabelledby = "--Select Lectures--"
        }

        return (
            <section className='assignment'>
                <Container>
                    <div className='d-flex justify-content-end'>
                        <div>
                            <Button className="btn text-uppercase creation_btn"  onClick={() => { this.setState({ assignmentCreationModal: true, existingAssignmentData: [], isEdit: false }) }}>Assignment Creation</Button>
                        </div>
                    </div>
                    <Row>

                        <Col xl={12} lg={12} md={12} sm={12}>
                            <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                                <h2 className="title h5 mb-0 text-uppercase">Assignments</h2>
                                <div className="filter-block d-flex align-items-center mr-4">
                                    <Form.Group className="customDate mb-0 mr-4" controlId="StartDate" style={{ width: 180 }}>
                                        <DateBlock applyCallback={this.applyCallback} start={this.start} end={this.end}
                                            stateData={this.props.stateData} data="Assignment"
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                        </Col>

                        <Col sm={12}>
                            <Form>
                                <Form.Row>
                                    <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranch">
                                        <Form.Label className="text-uppercase font-weight-bold">Branch</Form.Label>
                                        <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch} isInvalid={this.state.branchError}>
                                            <option >--Select Branch--</option>
                                            {this.props.globals.globalBranches.map(branchdata => (
                                                <option key={branchdata.id} value={branchdata.id}>
                                                    {branchdata.branch_name}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.branchError}
                                        </Form.Text>
                                    </Form.Group>


                                    <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectExam">
                                        <Form.Label className="text-uppercase font-weight-bold">Exam</Form.Label>
                                        <Form.Control as="select" name="exam" onChange={this.handleInputChange} value={this.state.exam} isInvalid={this.state.examError}>
                                            <option>--Select Exam--</option>
                                            {this.state.getExams.map(item => (
                                                <option key={item.value} value={item.value}>
                                                    {item.label}
                                                </option>
                                            ))}
                                        </Form.Control>
                                      
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.examError}
                                        </Form.Text>
                                    </Form.Group>


                                    <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                                        <Form.Label className="text-uppercase font-weight-bold">Class</Form.Label>
                                        <Form.Control as="select" name="class" onChange={this.handleInputChange} value={this.state.class} isInvalid={this.state.classError}>
                                            <option>--Select Class--</option>
                                            {this.state.getClasses.map(classdata => (
                                                <option key={classdata.value} value={classdata.value}>
                                                    {classdata.label}
                                                </option>
                                            ))}

                                        </Form.Control>
                                      
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.classError}
                                        </Form.Text>
                                    </Form.Group>

                                    <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectSection"  >
                                        <Form.Label className="text-uppercase font-weight-bold">Section</Form.Label>
                                        <MultiSelect
                                            overrideStrings={{
                                                "allItemsAreSelected": "All Sections are selected.",
                                                "selectSomeItems": sectionlabelledby
                                            }
                                            }
                                            disableSearch={sectiondisablesearch}
                                            hasSelectAll={sectionSelectAll}
                                            options={this.state.getSections}
                                            value={this.state.sectionValue}
                                            onChange={(e) => this.handleMultipleSelectInputChange(e, "sections")}
                                            labelledBy={"Sections"}
                                        />
                                        <Form.Text className="form-text text-danger">
                                            {this.state.sectionError}
                                        </Form.Text>
                                    </Form.Group>

                                    <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectSubject"  >
                                        <Form.Label className="text-uppercase font-weight-bold">Subject</Form.Label>
                                        <MultiSelect
                                            overrideStrings={{
                                                "allItemsAreSelected": "All Subjects are selected.",
                                                "selectSomeItems": subjectlabelledby
                                            }
                                            }
                                            disableSearch={subjectdisablesearch}
                                            hasSelectAll={subjectSelectAll}
                                            options={this.state.getSubjects}
                                            value={this.state.subjectValue}
                                            onChange={(e) => this.handleMultipleSelectInputChange(e, "subjects")}
                                            labelledBy={"Subjects"}
                                        />
                                        <Form.Text className="form-text text-danger">
                                            {this.state.subjectError}
                                        </Form.Text>
                                    </Form.Group>

                                    <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectLecture"  >
                                        <Form.Label className="text-uppercase font-weight-bold">Lecture Name</Form.Label>
                                        <MultiSelect
                                            overrideStrings={{
                                                "allItemsAreSelected": "All Lectures are selected.",
                                                "selectSomeItems": lecturelabelledby
                                            }
                                            }
                                            disableSearch={lecturedisablesearch}
                                            hasSelectAll={lectureSelectAll}
                                            options={this.state.getMainEmployees}
                                            value={this.state.lectureValue}
                                            onChange={(e) => this.handleMultipleSelectInputChange(e, "lectures")}
                                            labelledBy={"Lectures"}
                                        />
                                        <Form.Text className="form-text text-danger">
                                            {this.state.lecturerError}
                                        </Form.Text>
                                    </Form.Group>


                                    <Form.Group as={Col} lg={12} md={12} sm={12} controlId="Selectexam" className="d-flex justify-content-end">
                                        <Button className="btn  creation_btn text-uppercase " onClick={(e) => this.getDisplayData()}>Get Assignments</Button>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        </Col>
                    </Row>

                    {
                        this.state.assignCreationData.length > 0 ?

                            (
                                <Row>
                                    <Col sm={12}>
                                        <CardLessDataTable
                                            parentData={this.tableData(this.state.assignCreationData)}
                                            particlecolumns={this.articlecolumns}
                                            searchBar={false}
                                        />

                                    </Col>
                                </Row>
                            )
                            :
                            (
                                <Row>
                                    <Col sm={12}>
                                        <div className={this.state.loader == 1 ? "d-flex align-items-center spinner-border text-primary text-center loading-img-center" : ""} >
                                        </div>
                                    </Col>
                                    <Col sm={12}>
                                        {
                                            this.state.noDateError != "" ?
                                                (
                                                    <h6 className='d-flex justify-content-center align-content-center'>{this.state.noDateError}</h6>
                                                )
                                                :
                                                ("")
                                        }
                                    </Col>
                                </Row>
                            )
                    }

                    <AssignmentCreationModal
                        globals={this.props.globals}
                        stateData={this.state}
                        show={this.state.assignmentCreationModal}
                        onHide={() => this.setState({ assignmentCreationModal: false })}
                    />

                    <DeleteModal
                        globals={this.props.globals}
                        stateData={this.state}
                        show={this.state.deleteModal}
                        onHide={() => this.setState({ deleteModal: false })}
                        handleDelete={this.handleDelete}
                    />

                    <CreationDetailsModal
                        stateData={this.state}
                        show={this.state.creationDetailsModal}
                        onHide={() => this.setState({ creationDetailsModal: false })}
                    />

                </Container>
            </section >
        )
    }
}

export default
    withRouter(withApollo(
        graphql(DELETE_DIARY_ROW_DATA, {
            name: "deleteDairyAssignmentData"
        })
            (AssignmentHome)));